// Visibility-aware polling: stops firing while the tab is hidden and does an
// immediate refetch the moment it becomes visible again. Cuts backend load
// from backgrounded tabs with no change to foreground behaviour.
export function startPoll(fn, interval) {
  let timer = null;

  const start = () => {
    if (!timer) timer = setInterval(() => { if (!document.hidden) fn(); }, interval);
  };
  const stop = () => {
    if (timer) { clearInterval(timer); timer = null; }
  };
  const onVisibility = () => {
    if (document.hidden) {
      stop();
    } else {
      fn();
      start();
    }
  };

  document.addEventListener("visibilitychange", onVisibility);
  start();

  return () => {
    stop();
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
